// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3486T","header":"Messages_header__2m9xL"};